import { Box, Typography } from '@mui/material'
import ColoredMultySelect, {
  TValues,
} from 'components/ui/ColoredMultySelect/ColoredMultySelect'
import { FILTERS_MODE } from '../DataAnalysisFilters'

interface BinFilterProps {
  bins: any[]
  selectedBins: string[]
  onBinsChange: (bins: string[]) => void
}

export const BinFilter = ({
  bins,
  selectedBins,
  onBinsChange,
}: BinFilterProps) => {
  const options: TValues[] = bins.map((bin: any) => ({
    id: Number(bin.id),
    name: String(bin.name),
    color: bin?.color?.hex_code,
    checked: selectedBins.includes(String(bin.name)),
  }))

  return (
    <Box>
      <Typography>Bins</Typography>
      <ColoredMultySelect
        valuesList={options}
        isSquare={true}
        mode={FILTERS_MODE.LIST}
        handleListChange={onBinsChange}
      />
    </Box>
  )
}
